import { DEFAULT_GROUP, gql } from "@edreamsodigeo/frontend-api-client";

import { LOGIN_RESPONSE_FRAGMENT } from "../../fragments";
import { AUTH_CHANGE_GROUP, LOGIN_GROUP } from "../../groups";

const GOOGLE_LOGIN_MUTATION = gql`
  ${LOGIN_RESPONSE_FRAGMENT}
  mutation GoogleLogin($request: GoogleLoginRequest!)
  @update_groups(groups: "${DEFAULT_GROUP},${AUTH_CHANGE_GROUP},${LOGIN_GROUP},googleLogin") {
    googleLogin(request: $request) {
      ...LoginResponseParts
    }
  }
`;

export default GOOGLE_LOGIN_MUTATION;
